/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-04-08 20:58:06 */

const Keys = {
  BACK_TO_LIST: 'BACK_TO_LIST',
  noResultsWarningHeader: 'noResultsWarningHeader',
  emptyResultsWarning: 'emptyResultsWarning',
  emptyFilteringResultsWarning: 'emptyFilteringResultsWarning',
  apiNotAbleToGetCampersResults: 'apiNotAbleToGetCampersResults',
  apiNotAbleToGetCampersDetails: 'apiNotAbleToGetCampersDetails',
  apiNotAbleToAddItemToBooking: 'apiNotAbleToAddItemToBooking',
  change: 'change',
  results: 'results',
  results_plural: 'results_plural',
  numberOfSuppliers: 'numberOfSuppliers',
  numberOfSuppliers_plural: 'numberOfSuppliers_plural',
  inCity: 'inCity',
  SUPPLIER_COMPARE: 'SUPPLIER_COMPARE',
  productNotAvailable: 'productNotAvailable',
  resultList: 'resultList',
  details: 'details'
}; export default Keys;